import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import "./common/styles/components/header.css";
import "./common/styles/webflow.css";
import "./common/styles/normalize.css";
import "./common/styles/admin-sanitas.webflow.css";
import "./App.css";
import OtpGetPage from "./pages/otp/OtpGetPage";
import OtpConfirmationPage from "./pages/otp/OtpConfirmationPage";
import ConfirmationPassword from "./pages/forgotPassword/ConfirmationPassword";
import Congratulations from "./pages/congratulations/Congratulations";
import RegisterPage from "./pages/register/RegisterPage";
import Error from "./pages/error/Error";
import ErrorWhite from "./pages/error/ErrorWhite";
import ForgotPassword from "./pages/forgotPassword/ForgotPassword";
import MyProfile from "./pages/user/MyProfile";
import DetailsUser from "./pages/user/home";
import DatosPerson from "./pages/update-data/DatosPerson";
import ConfirmationPerson from "./pages/update-data/ConfirmationPerson";
import UpdatePerson from "./pages/update-data/UpdatePerson";
import ContractPage from "./pages/contract/ContractPage";
import ContractDetail from "./pages/contract/ContractDetail";
import FamilyComposition from "./pages/contract/FamilyComposition";
import MedicalConditions from "./pages/contract/MedicalConditions";
import MedicalConditionsForm from "./pages/contract/MedicalConditionsForm";
//import Reembolsos from "./pages/reembolsos/Reembolsos";
//import ReembolsosRealiza from "./pages/reembolsos/ReembolsosRealiza";
//import ReembolsosRegister from "./pages/reembolsos/ReembolsosRegister";
import { AuthProvider } from "./common/provider/authContextType";
//import ReembolososSolict from "./pages/reembolsos/ReembolososSolict";
//import Search from "./pages/search/Search";
import { useEffect } from "react";
//import SearchLeaflet from "./pages/search/SearchLeaflet";
//import VirtualCare from "./pages/search/SearchDetail";

interface AppProps {
  properties: {
    client_id: string | null;
    client_secret: string | null;
    origin: string | null;
    expirationTime: number;
  };
}
const App: React.FC<AppProps> = ({ properties }) => {
  useEffect(() => {
    const cookies = document.cookie.split("; ");

    const getCookieValue = (key: string): string | null => {
      const cookie = cookies.find((c) => c.startsWith(`${key}=`));
      return cookie ? cookie.split("=")[1] : null;
    };

    const token = getCookieValue("auth_token");
    const tipoDoc = getCookieValue("tipodedoc");
    const documento = getCookieValue("documentonumero");

    // Validar que existan todos los valores
    if (token && tipoDoc && documento) {
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("tipodedoc", tipoDoc);
      sessionStorage.setItem("documentonumero", documento);

      // Opcional: borrar cookies después de usarlas
      document.cookie = "auth_token=; path=/; max-age=0";
      document.cookie = "tipodedoc=; path=/; max-age=0";
      document.cookie = "documentonumero=; path=/; max-age=0";
    } else {
      console.warn("No se encontraron todas las cookies necesarias");
    }
  }, []);

  // --- Fin agregado ---
  return (
    <HashRouter>
      <div className="page-wrapper">
        <div className="global-styles w-embed"></div>
        <main className="main-wrapper">
          <Routes>
            <Route path="/mi-perfil" element={<MyProfile />}>
              <Route index element={<DetailsUser />} />
              <Route path="datos-personales" element={<DatosPerson />} />
              <Route
                path="estas-seguro-de-actualizar-tu-informacion"
                element={<ConfirmationPerson />}
              />
              <Route path="actualiza-tus-datos" element={<UpdatePerson />} />
              <Route
                path="confirmacion-datos-actualizados"
                element={
                  <Congratulations
                    mensaje="Tus datos fueron actualizados."
                    labelButton="Ver mi perfil"
                    header="Tus datos han sido actualizados con éxito"
                    to="#/mi-perfil"
                  />
                }
              />
              <Route path="contratos" element={<ContractPage />} />
              <Route path="detalle-contrato" element={<ContractDetail />} />
              <Route
                path="composicion-familiar"
                element={<FamilyComposition />}
              />
              <Route
                path="condiciones-medicas"
                element={<MedicalConditions />}
              />
              <Route
                path="condiciones-medicas-formulario"
                element={<MedicalConditionsForm />}
              />
              <Route path="error-actualizar" element={<ErrorWhite />} />
              <Route path="error-afiliado" element={<ErrorWhite />} />
              {/* <Route path="reembolsos" element={<Reembolsos />} />
              <Route
                path="reembolsos-registro"
                element={<ReembolsosRegister />}
              />
              <Route
                path="reembolsos-realiza"
                element={<ReembolsosRealiza />}
              />
              <Route
                path="reembolsos-solicitudes"
                element={<ReembolososSolict />}
              />*/}
              <Route
                path="reembolsos-registro-exitoso"
                element={
                  <Congratulations
                    mensaje="Fue registrado tu reembolso correctamente. "
                    labelButton="Ver mi perfil"
                    header="Tu reembolso ha sido registrado con éxito"
                    to="#/mi-perfil"
                  />
                }
              />              
            </Route>
            {/* <Route path="buscador-de-clinicas" element={<Search />} />
            <Route path="buscador-de-clinicas-leaflet" element={<SearchLeaflet />} />
            <Route path="virtual-care" element={<VirtualCare />} /> */}
            <Route path="/quiero-registrarme">
              <Route path="registro-dni" element={<RegisterPage />} />
              <Route
                path="paso-1-verificacion"
                element={<OtpGetPage option="register" />}
              />
              <Route
                path="paso-2-validacion-de-codigo"
                element={<OtpConfirmationPage option="register" />}
              />
              <Route
                path="paso-3-contrasena"
                element={<ConfirmationPassword option="register" />}
              />
              <Route
                path="confirmacion-de-registro"
                element={
                  <Congratulations
                    mensaje="Registro correcto."
                    labelButton="Ingresa a tu usuario"
                    header="Ahora puedes iniciar sesión con tu nueva contraseña"
                    to="/"
                  />
                }
              />
              <Route path="error-de-registro-dni" element={<Error />} />
              <Route path="error-registrar" element={<ErrorWhite />} />
            </Route>
            <Route path="/olvide-contrasena">
              <Route path="olvide-mi-contrasena" element={<ForgotPassword />} />
              <Route
                path="paso-1---actualizar"
                element={<OtpGetPage option="forgotPassword" />}
              />
              <Route
                path="paso-2-validacion-de-codigo"
                element={<OtpConfirmationPage option="forgotPassword" />}
              />
              <Route
                path="paso-3---actualizar"
                element={<ConfirmationPassword option="forgotPassword" />}
              />
              <Route
                path="confirmacion-de-cambio-de-contrasena"
                element={
                  <Congratulations
                    mensaje="Tu constraseña fue reestablecida"
                    labelButton="Ingresa a tu usuario"
                    header="Ahora puedes iniciar sesión con tu nueva contraseña"
                    to="/"
                  />
                }
              />
              <Route path="error-de-actualizar-dni" element={<Error />} />
              <Route path="error-olvide" element={<ErrorWhite />} />
            </Route>
            <Route path="error-de-autenticacion" element={<ErrorWhite />} />
          </Routes>
        </main>
      </div>
    </HashRouter>
  );
};
const AppWithProvider: React.FC<AppProps> = (props) => (
  <AuthProvider
    origin={props.properties.origin}
    expirationTime={props.properties.expirationTime}
  >
    <App {...props} />
  </AuthProvider>
);

export default AppWithProvider;
